import { Controller } from '@hotwired/stimulus';
import AutoNumeric from 'autonumeric';

export default class extends Controller {
  static targets = ['input', 'inputInteger'];

  initialize() {
    this.inputTargets.forEach(function (input) {
      new AutoNumeric(input, {
        digitGroupSeparator: ' ',
        modifyValueOnWheel: false,
        decimalPlaces: 2,
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        onInvalidPaste: 'ignore',
      });
    });

    // backend sanitization required because of group separator
    // without that e.g. find("18 883") will search for id 18 instead of 18_883
    this.inputIntegerTargets.forEach(function (input) {
      new AutoNumeric(input, {
        modifyValueOnWheel: false,
        digitGroupSeparator: ' ',
        decimalPlaces: 0,
      });
    });
  }
}
